"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
class TypePackageDef {
    constructor(packageNs, definitions) {
        this.packageNs = packageNs;
        this.definitions = definitions;
    }
    getUsedNamespaces() {
        const s = new Set();
        for (const type of Object.values(this.definitions)) {
            type.collectUsedNamespaces(s);
        }
        return s;
    }
    addToTypeSystem(typeSystem) {
        for (const [defName, def] of Object.entries(this.definitions)) {
            const name = this.packageNs(defName);
            const typeDef = def.toType(typeSystem);
            typeSystem.defineType(name, typeDef);
        }
    }
}
exports.TypePackageDef = TypePackageDef;
class BaseTypeDef {
}
exports.BaseTypeDef = BaseTypeDef;
class TypeRefDef extends BaseTypeDef {
    constructor(namespacedName) {
        super();
        this.namespacedName = namespacedName;
    }
    collectUsedNamespaces(set) {
        set.add(this.namespacedName.namespace);
    }
    toType(typeSystem) {
        return typeSystem.getOrCreateType(this.namespacedName);
    }
}
exports.TypeRefDef = TypeRefDef;
class CustomTypeDef extends BaseTypeDef {
    constructor(type) {
        super();
        this.type = type;
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.CustomType(this.type);
    }
}
exports.CustomTypeDef = CustomTypeDef;
class UnionTypeDef extends BaseTypeDef {
    constructor(of) {
        super();
        this.of = of;
        this.kind = "union";
    }
    collectUsedNamespaces(set) {
        for (const t of this.of) {
            t.collectUsedNamespaces(set);
        }
    }
    toType(typeSystem) {
        return new types_1.UnionType(this.of.map(t => t.toType(typeSystem)));
    }
}
exports.UnionTypeDef = UnionTypeDef;
class IntersectionTypeDef extends BaseTypeDef {
    constructor(of) {
        super();
        this.of = of;
        this.kind = "intersection";
    }
    collectUsedNamespaces(set) {
        for (const t of this.of) {
            t.collectUsedNamespaces(set);
        }
    }
    toType(typeSystem) {
        return new types_1.IntersectionType(this.of.map(t => t.toType(typeSystem)));
    }
}
exports.IntersectionTypeDef = IntersectionTypeDef;
class StringTypeDef extends BaseTypeDef {
    constructor() {
        super(...arguments);
        this.kind = "string";
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.StringType();
    }
}
exports.StringTypeDef = StringTypeDef;
class NumberTypeDef extends BaseTypeDef {
    constructor() {
        super(...arguments);
        this.kind = "number";
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.NumberType();
    }
}
exports.NumberTypeDef = NumberTypeDef;
class BooleanTypeDef extends BaseTypeDef {
    constructor() {
        super(...arguments);
        this.kind = "boolean";
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.BooleanType();
    }
}
exports.BooleanTypeDef = BooleanTypeDef;
class AnyTypeDef extends BaseTypeDef {
    constructor() {
        super(...arguments);
        this.kind = "any";
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.AnyType();
    }
}
exports.AnyTypeDef = AnyTypeDef;
class LiteralTypeDef extends BaseTypeDef {
    constructor(value) {
        super();
        this.value = value;
        this.kind = "literal";
    }
    collectUsedNamespaces(set) { }
    toType(typeSystem) {
        return new types_1.LiteralType(this.value);
    }
}
exports.LiteralTypeDef = LiteralTypeDef;
class ObjectTypeDef extends BaseTypeDef {
    constructor(properties) {
        super();
        this.properties = properties;
        this.kind = "object";
    }
    collectUsedNamespaces(set) {
        for (const t of Object.values(this.properties)) {
            t.type.collectUsedNamespaces(set);
        }
    }
    toType(typeSystem) {
        return new types_1.ObjectType(Object.fromEntries(Object.entries(this.properties).map(([propertyName, propertyInfo]) => [
            propertyName,
            new types_1.ObjectProperty(propertyName, propertyInfo.type.toType(typeSystem), propertyInfo.optional, propertyInfo.defaultValue),
        ])));
    }
}
exports.ObjectTypeDef = ObjectTypeDef;
class ObjectPropertyDef {
    constructor(type, optional, defaultValue) {
        this.type = type;
        this.optional = optional;
        this.defaultValue = defaultValue;
    }
}
exports.ObjectPropertyDef = ObjectPropertyDef;
class ArrayTypeDef extends BaseTypeDef {
    constructor(itemType) {
        super();
        this.itemType = itemType;
        this.kind = "array";
    }
    collectUsedNamespaces(set) {
        this.itemType.collectUsedNamespaces(set);
    }
    toType(typeSystem) {
        return new types_1.ArrayType(this.itemType.toType(typeSystem));
    }
}
exports.ArrayTypeDef = ArrayTypeDef;
class MapTypeDef extends BaseTypeDef {
    constructor(valueType) {
        super();
        this.valueType = valueType;
        this.kind = "map";
    }
    collectUsedNamespaces(set) {
        this.valueType.collectUsedNamespaces(set);
    }
    toType(typeSystem) {
        return new types_1.MapType(this.valueType.toType(typeSystem));
    }
}
exports.MapTypeDef = MapTypeDef;
//# sourceMappingURL=typeDefs.js.map